import { type FC } from 'react'

import { PimVariantAttributeV1TypeEnum } from '@redteclab/api/clients/bully'

import { type AttributeGroupData } from '../../product-page-context/useProductPageAttributeSelectionControls'

import { ProductAttributeTileWithPriceGroup } from './ProductAttributeTileWithPriceGroup'
import { ProductPageColorTypeAttributeGroup } from './ProductPageColorTypeAttributeGroup'
import { ProductPageListTypeAttributeGroup } from './ProductPageListTypeAttributeGroup'
import { ProductPageTextTypeAttributeGroup } from './ProductPageTextTypeAttributeGroup'

interface ProductPageAttributeSelectionGroupRendererProps {
  attributeGroup: AttributeGroupData
  isSingleGroup: boolean
}

export const ProductPageAttributeSelectionGroupRenderer: FC<
  ProductPageAttributeSelectionGroupRendererProps
> = (props) => {
  const {
    attributeGroup,
    attributeGroup: { metaAttributeData, shouldShowPricesOnSelections },
    isSingleGroup,
  } = props

  if (shouldShowPricesOnSelections) {
    return (
      <ProductAttributeTileWithPriceGroup
        attributeGroup={attributeGroup}
        isSingleGroup={isSingleGroup}
      />
    )
  }

  if (metaAttributeData.type === PimVariantAttributeV1TypeEnum.Color) {
    return (
      <ProductPageColorTypeAttributeGroup
        attributeGroup={attributeGroup}
        isSingleGroup={isSingleGroup}
      />
    )
  }

  if (metaAttributeData.type === PimVariantAttributeV1TypeEnum.List) {
    return <ProductPageListTypeAttributeGroup attributeGroup={attributeGroup} />
  }

  return (
    <ProductPageTextTypeAttributeGroup
      attributeGroup={attributeGroup}
      isSingleGroup={isSingleGroup}
    />
  )
}
